import React from "react";
import { useEffect, useState } from "react";
import { getFuzzyTime } from "../../utils/timeFormatter";

interface FuzzyTimeProps {
  timestamp: number;
}

export const FuzzyTime = ({ timestamp }: FuzzyTimeProps) => {
  const [time, setTime] = useState<string>("");

  useEffect(() => {
    setTime(getFuzzyTime(timestamp));

    const intervalId = window.setInterval(() => {
      const fuzzyTime = getFuzzyTime(timestamp);
      setTime(fuzzyTime);
      if (fuzzyTime.includes(":")) {
        clearInterval(intervalId);
      }
    }, 5000);

    return () => {
      clearInterval(intervalId);
    };
  }, [timestamp]);

  return <React.Fragment>{time}</React.Fragment>;
};
